const poster = require('../assets/poster.png')

export {
  poster as IMG_POSTER
}

import html2canvas from "html2canvas"
export const DOM_TO_IMG = (ele, options, callback) => {
    let dic = {useCORS: true, backgroundColor: "transparent"}
    dic = {...dic, ...options};
    console.log(dic)
    html2canvas(ele, dic).then(canvas => {
        let url = canvas.toDataURL('image/jpeg', 1.0);
        if(callback){
            callback(url, canvas);
        }
    });
}
